export function isEmpty(value) {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    if (Array.isArray(value) && value.length === 0) {
      return true;
    }
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      return true;
    }
    return false;
  }

  export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!emailRegex.test(email)) {
      return false;
    }
    return true; // Email is valid
  };

  export function generateYearListDesc() {
    const currentYear = new Date().getFullYear(); // 获取当前年份
    const yearList = [];
    for (let year = currentYear; year >= 1980; year--) {
      yearList.push(year);
    }
    return yearList;
  }

  export function generatePriceList(val) {
    const priceList = [];
    for (let i = 0; i <= 100; i++) {
      let priceValue = 0;
      if(val === 'ja'){
        priceValue = i * 100000; // 价格数值
      } else {
        priceValue = i * 1000;
      }
      
      priceList.push({
        name_ja: `${i * 10}万円`,     // 日语显示形式
        name_en: `${i * 1000} USD`, // 英语显示形式
        code: `${priceValue}`        // 实际的价格代码（单位为日元）
      });
    }
    return priceList;
  };

  export function formatToYen(amount) {
    if (typeof amount !== "string" || isNaN(Number(amount))) {
      throw new Error("Input must be a valid numeric string");
    }
    const number = Number(amount);
    return `¥${number.toLocaleString("en-US")}`;
  }

  export function formatToYen2(amount, currency) {
    if (typeof amount !== "string" || isNaN(Number(amount))) {
      throw new Error("Input must be a valid numeric string");
    }
  
    const number = Number(amount);
  
    if (currency === "ja") {
      return `¥${number.toLocaleString("en-US")} <small>(JPY)</small>`;
    } else if (currency === "en") {
      return `$${number.toLocaleString("en-US")} <small>(USD)</small>`;
    } else {
      throw new Error("Unsupported currency type. Use 'JP' or 'US'.");
    }
  }


  // 格式化年份和月份
export function formatYearMonth(value, locale) {
  if (!value) return '';
  if (locale === 'ja') {
    return `${value.slice(0, 4)}年${value.slice(4, 6)}月`;
  } else {
    const date = new Date(value.slice(0, 4), value.slice(4, 6) - 1);
    return date.toLocaleString('en-US', { year: 'numeric', month: 'long' });
  }
}

// 格式化公里数（添加千位分隔符并加单位）
export function formatMileage(value) {
  if (!value) return '';
  return `${Number(value).toLocaleString()}km`;
}

// 格式化公里数或英里数（添加千位分隔符并加单位）
export function formatMileage2(value, lang = 'jp') {
  if (!value) return '';
  
  const unit = lang.toLowerCase() === 'en' ? 'mi' : 'km';
  return `${Number(value).toLocaleString()}${unit}`;
}

// 格式化排量（添加千位分隔符并加单位）
export function formatDisplacement(value) {
  if (!value) return '';
  return `${Number(value).toLocaleString()}cc`;
}

// 格式化年份、月份和日期
export function formatYearMonthDay(value, locale) {
  if (!value || value.length !== 8) return ''; // 确保传入的是 yyyyMMdd 格式
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);

  if (locale === 'ja') {
    return `${year}年${month}月${day}日`; // 日本語形式
  } else {
    const date = new Date(year, month - 1, day);
    return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); // 英文格式
  }
}

export function formatYen(value, locale) {
  if (!value || isNaN(value)) return "";

  const num = parseInt(value, 10);

  if (locale === "ja") {
    return `¥${Math.round(num / 10000)}万円`;
  } else {
    return `¥${(num / 1000000).toFixed(2)} M`;
  }
}

// 格式化年份、月份
export function formatYearMonth2(value) {
  if (!value || value.length !== 6) return ''; // 确保传入的是 yyyyMM 格式
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);

 
  return `${year}/${month}`; // 日本語形式

}
// 格式化年份、月份和日期
export function formatYearMonthDay2(value) {
  if (!value || value.length !== 8) return ''; // 确保传入的是 yyyyMMdd 格式
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);

  
    return `${year}/${month}/${day}`; // 日本語形式
  
}